import { AdviserSearch } from './adviser-search';
import './dots';
import { initContactForm } from './contact-form';

document.addEventListener('DOMContentLoaded', () => {
    try {
        const apiKey = 'RwPk8H4-UUefyTuudzFAAA36205';
        const searchElement = document.getElementById('adviser-search-input');
        
        // Only initialize AdviserSearch if we're on a page with the search
        if (searchElement) {
            new AdviserSearch(apiKey);
        }
        initContactForm();
    } catch (error) {
        console.error('Error in initialization:', error);
        // Still try to initialize the contact form even if search fails
        initContactForm();
    }
});